@if (!readOnly()) {
  <div class="add-button">
    <button mat-mini-fab matTooltip="Agregar nueva dirección de facturación" (click)="openBillingInfoForm()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
}
<div class="billing-infos">
  @if (selectionMode() && !readOnly()) {
    <mat-radio-group [(ngModel)]="selectedBillingInfo" (ngModelChange)="onSelectBillingInfo($event)">
      @for (billing_info of entity().billing_infos; track billing_info.id) {
        <div class="billing-info">
          <mat-radio-button [value]="billing_info"></mat-radio-button>
          <ng-container *ngTemplateOutlet="billing_info_card; context: {billing_info: billing_info}"></ng-container>
        </div>
      }
    </mat-radio-group>
  } @else {
    @for (billing_info of entity().billing_infos; track billing_info.id) {
      <div class="billing-info">
        <ng-container *ngTemplateOutlet="billing_info_card; context: {billing_info: billing_info}"></ng-container>
      </div>
    }
  } 
</div>

<ng-template #formTemplate>
  <div mat-dialog-content class="dialog-content">
    <h2 mat-dialog-title>Agregar nueva dirección de facturación</h2>

    <button mat-mini-fab class="primary" (click)="prefillFormWithEntityData()" matTooltip="Prerellenar con información del {{entity_type() | human}}">
      <mat-icon>auto_fix_high</mat-icon>
    </button>
    
    <br />
    <br />
    
    <form [formGroup]="form">
      <div class="form-row">
        <mat-form-field [floatLabel]="'always'">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name" placeholder="Direccion 1" />
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field floatLabel="always">
          <mat-label>Dirección</mat-label>
          <input matInput formControlName="street_address" placeholder="ej. Macul 123"/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Ciudad</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Estado / Región</mat-label>
          <input matInput formControlName="state" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Código postal</mat-label>
          <input matInput formControlName="zip_code" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Correo Electrónico</mat-label>
          <input matInput formControlName="email_address" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Teléfono</mat-label>
          <input matInput formControlName="phone_number" />
        </mat-form-field>
      </div>
      <div class="buttons">
        <button mat-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button class="primary" (click)="saveBillingInfo()" [disabled]="!form.valid || saving()">
          @if (saving()) {
            <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
          }
          @else {
            Guardar
          }
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #billing_info_card let-billing_info="billing_info">
  <mat-card appearance="outlined" class="billing-info-card">
    <mat-card-content>
      <div class="billing-info-wrapper">
        <div>
          <div>{{ billing_info.name }}</div>
          <div><small>{{ billing_info.street_address }}</small></div>
          <div><small>{{ billing_info.city }}</small></div>
          <div><small>{{ billing_info.state }}</small></div>
        </div> 
        <div>
          <div>
            <button mat-icon-button class="edit-button" (click)="openBillingInfoForm(billing_info)">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <div>
            <button mat-icon-button class="delete-button" (click)="deleteBillingInfo(billing_info.id)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>


